import {
  CreateInstitutionInput,
  CreateInstitutionMutation,
  DeleteInstitutionInput,
  DeleteInstitutionMutation,
  GetInstitutionQuery,
  Institution,
  ListInstitutionsQuery,
  ModelInstitutionConnection,
  UpdateInstitutionInput,
  UpdateInstitutionMutation
} from "../../API";
import * as queries from "../../graphql/queries";
import * as mutations from "../../graphql/mutations";
import { genericQuery, fetchAllWithPagination } from "../api/apiUtils";
import { API } from "aws-amplify";

export const fetchAllInstitutions = async (): Promise<Institution[] | null> => {
  return await fetchAllWithPagination<Institution>(
    "institutions",
    "institutions",
    500
  );
};

export const fetchInstitution = async (id: string) =>
  (await API.get("simpl-api", `institutions/${id}`, {})) as Institution;

export async function updateInstitution(input: UpdateInstitutionInput) {
  const path = `institution/${input.id}`;

  try {
    const updatedInstitution = (await API.put("simpl-api", path, {
      body: input
    })) as Institution;

    return updatedInstitution;
  } catch (error) {
    console.error(
      `Error updating institution: with input: ${JSON.stringify(
        input,
        null,
        2
      )}\nError: ${JSON.stringify(error, null, 2)}`
    );
    throw error;
  }
}

export const createInstitution = async (input: CreateInstitutionInput) => {
  const path = "institution";

  try {
    const createdInstitution = (await API.put("simpl-api", path, {
      body: input
    })) as CreateInstitutionResult;

    return createdInstitution.result[0];
  } catch (error) {
    console.error(
      `Error creating institution: with input: ${JSON.stringify(
        input,
        null,
        2
      )}\nError: ${JSON.stringify(error, null, 2)}`
    );
    throw error;
  }
};

export const deleteInstitution = async (input: DeleteInstitutionInput) => {
  const predicate = { input: input };
  return await genericQuery<DeleteInstitutionMutation, Institution>(
    mutations.deleteInstitution,
    "deleteInstitution",
    predicate
  );
};
